<template>
  <div>
    <h1>404</h1>
  </div>
</template>

<script>
export default {
  name: 'page-404',
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>
